import React, { useEffect, useRef, useState } from 'react';
import { Button, Card, Stack } from '@mui/material';
import JsFileDownloader from 'js-file-download';
import Iconify from '../common/iconify.component';
import ListData from '../table-elements/list-data.component';
import SearchList from '../table-elements/search-list.component';
import {
  LISTING_ACTIONS,
  LISTING_COLUMNS,
} from '../../config/module-configs/contacts.config';
import { getContactList, getExportData } from '../../services/contacts.service';
import {
  checkAdminUserRole,
} from '../../utils/local-cache.util';

const ListContacts = () => {
  const columns = LISTING_COLUMNS;
  const actions = LISTING_ACTIONS;
  
  const [adminUserRole, setAdminUserRole] = useState('');
  const getAdminRole = checkAdminUserRole();

  const searchContactsRef = useRef(null);
  const [options, setOptions] = useState({
    page: 0,
    rowsPerPage: 10,
    totalRows: 0,
    rows: [],
    reloadCounter: 0,
    sortBy: '',
    sortOrder: '',
    q: null,
    error: false,
    loading: true,
    searchValue: '',
  });

  const handlePageChange = (v) => {
    setOptions({
      ...options,
      page: v,
      reloadCounter: options.reloadCounter + 1,
      loading: true,
    });
  };

  const handleRowsPerPageChange = (v) => {
    setOptions({
      ...options,
      rowsPerPage: v,
      page: 0,
      reloadCounter: options.reloadCounter + 1,
      loading: true,
    });
  };

  const handleSortingChange = (sortBy, sortOrder) => {
    setOptions({
      ...options,
      sortBy,
      sortOrder,
      reloadCounter: options.reloadCounter + 1,
      loading: true,
    });
  };

  const handleRefreshData = () => {
    setOptions({
      ...options,
      reloadCounter: options.reloadCounter + 1,
      loading: true,
    });
  };

  const handleSearchChange = (e) => {
    setOptions({
      ...options,
      searchValue: e.target.value || '',
    });
  };

  const handleSearchContacts = () => {
    setOptions({
      ...options,
      q: searchContactsRef.current.value,
      reloadCounter: options.reloadCounter + 1,
      page: 0,
    });
  };

  const handleClearSearch = () => {
    setOptions({
      ...options,
      searchValue: '',
      q: null,
      reloadCounter: options.reloadCounter + 1,
    });
    searchContactsRef.current.value = '';
  };

  const downloadContactSubscriberMinistryData = () => {
    const downloadFileName = `contacts`;
    setAdminUserRole(getAdminRole);
    getExportData()
      .then((res) => {
        // eslint-disable-next-line no-unused-vars
        const download = new JsFileDownloader(res, `${downloadFileName}.csv`);
      })
      .catch(() => {
        // to do
      });
  };

  const dataListAPICall = (newOptions = {}) => {
    setAdminUserRole(getAdminRole);
    let params = '';
    params = `?page=${newOptions?.page || options.page + 1}`;
    params += `&perPage=${options.rowsPerPage}`;
    params += `&adminUserRole=${getAdminRole}`;
    if (options.sortBy && options.sortOrder) {
      params += `&sortBy=${options.sortBy}`;
      params += `&sortOrder=${options.sortOrder}`;
    }
    if (options.q) {
      params += `&q=${options.q}`;
    } else if (searchContactsRef.current?.value) {
      params += `&q=${searchContactsRef.current.value}`;
    }


    setOptions({ ...options, loading: true, searchValue: '' });

    getContactList(params)
      .then((res) => {
        setOptions({
          ...options,
          loading: false,
          totalRows: res?.data?.totalRows || 0,
          rows: res?.data?.rows || [],
          q: null,
          error: false,
        });
      })
      .catch(() => {
        setOptions({
          ...options,
          loading: false,
          page: 0,
          totalRows: 0,
          rows: [],
          q: null,
          error: true,
        });
      });
  };

  useEffect(() => {
    const newOptions = options;
    newOptions.page = 0;
    setOptions({
      ...options,
      page: 0,
    });

    if (searchContactsRef.current?.value) {
      searchContactsRef.current.value = null;
    }
    dataListAPICall(newOptions);
  }, []);

  useEffect(() => {
    dataListAPICall();
  }, [options.reloadCounter]);

  return (
    <>
      <Stack
        direction="row"
        justifyContent="space-between"
        sx={{ px: 1, py: 2 }}
      >
        <div>
          <SearchList
            label="Contact"
            handleSearch={handleSearchContacts}
            inputRef={searchContactsRef}
            onChange={handleSearchChange}
            options={options}
            clearSearch={handleClearSearch}
            loading={options.loading}
          />
        </div>
        <Stack direction="row" alignItems="center" spacing={2}>
          <div
            style={{
              fontWeight: 500,
              fontSize: '16px',
              color: '#555',
            }}
          >
            Total Count : <strong>{options.totalRows}</strong>
          </div>
          <Button
            variant="contained"
            sx={{ my: 2, marginRight: 2 }}
            onClick={downloadContactSubscriberMinistryData}
          >
            Download CSV
          </Button>
          <Button
            color="inherit"
            startIcon={<Iconify icon="ic:twotone-refresh" />}
            onClick={handleRefreshData}
            disabled={options.loading}
          >
            Refresh
          </Button>
        </Stack>
      </Stack>

      <Card>
        <ListData
          columns={columns}
          rows={options.rows}
          page={options.page}
          rowsPerPage={options.rowsPerPage}
          totalRows={options.totalRows}
          loading={options.loading}
          actions={actions}
          error={options.error}
          sortBy={options.sortBy}
          sortOrder={options.sortOrder}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
          onSortChange={handleSortingChange}
          adminUserRole={adminUserRole}
        />
      </Card>
    </>
  );
};

export default ListContacts;
